'use strict'

import './autoin.scss'//Extracted by MiniCssExtractPlugin

import * as bootstrap from 'bootstrap';

// 1. Add required class to parenty as most browsers don't support :has() yet
document.querySelectorAll(".form-control[required]").forEach(el => el.parentElement.classList.add('fc-required'));

// 2.Tooltips
document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => new bootstrap.Tooltip(el));

// 3. Popover
//document.querySelectorAll('[data-bs-toggle="popover"]').forEach(el => new bootstrap.Popover(el));

// Custom: Add class to nav when "stuck" (assumes scrips are loaded in footer)
const mainnav = document.querySelector('header.sticky-top'), topHeader = document.getElementById('top-header');
if (mainnav !== null && topHeader !== null)
{
    (new IntersectionObserver(
        ([e]) => mainnav.classList.toggle('sticky-is-stuck', e.intersectionRatio < 0.0001),
        {threshold: [0.0001]}
    )).observe(topHeader);
}

export { bootstrap };
